import {
    ACTION_LOADING,
    ACTION_SUCCESS,
    ACTION_ERROR,
    ACTION_SUBMITING,
    ACTION_SUBMITED,
    GET_SMSNOTIFICATIONS,
    GET_SMSNOTIFICATIONS_LIST,
    SMSNOTIFICATIONS_SEARCH,

} from "../../actions/admin/SmsNotificationActions";

const initialState = {
    currentAds: {},
    smsNotificationList: [],
    adsSearchResult: {},
    loading: false,
    success: false,
    failed: false,
    submitting: false
};

const SmsNotificationReducer = function (state = initialState, action) {
    switch (action.type) {

        case ACTION_LOADING: {
            return {
                ...state,
                loading: true,
                success: false,
                failed: false
            };
        }
        case ACTION_SUCCESS: {
            return {
                ...state,
                success: true,
                loading: false,
                failed: false,
            };
        }
        case ACTION_ERROR: {
            return {
                ...state,
                failed: true,
                success: false,
                loading: false,
                showAlert: true,
                alertMessage: action.data,
            };
        }
        case ACTION_SUBMITING: {
            return {
                ...state,
                submitting: true
            };
        }
        case ACTION_SUBMITED: {
            return {
                ...state,
                submitting: false
            };
        }
        case GET_SMSNOTIFICATIONS_LIST: {
            return {
                ...state,
                smsNotificationList: [...action.data]
            };
        }
        case SMSNOTIFICATIONS_SEARCH: {
            return {
                ...state,
                adsSearchResult: { ...action.data }
            };
        }

        case GET_SMSNOTIFICATIONS: {
            return {
                ...state,
                currentSmsNotification: { ...action.data }
            };
        }
        default: {
            return state;
        }
    }
};

export default SmsNotificationReducer;
